// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../Fuel/font/digital-7.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*media breaks*/
@font-face {
  font-family: "digital-clock-font";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.epos__products {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.epos__products input::-webkit-outer-spin-button,
.epos__products input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.epos__products .epos__search {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: 72.1vh;
  position: relative;
  width: 100%;
}
.epos__products .epos__search #add_prod_btn {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 200px;
}
.epos__products .epos__search #add_prod_btn_bottom {
  display: flex;
  justify-content: end;
}
.epos__products .epos__search #add_prod_btn_bottom button {
  margin-top: 1vh;
  width: 200px;
}
.epos__products .epos__search .epos_search {
  border: 1px solid #2c53a0;
  width: 90vw;
  background-color: #fff;
  border-radius: 0.3rem;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 5px;
  padding: 10px;
}
.epos__products .epos__search .epos_search .search_area {
  width: 48%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  position: relative;
}
.epos__products .epos__search .epos_search .search_area input,
.epos__products .epos__search .epos_search .search_area select {
  height: 5vh;
  width: 100%;
  border-radius: 0.3rem;
  outline: none;
  padding: 2px 5px;
  border: 1px solid rgb(179, 172, 172);
}
.epos__products .epos__search .epos_search .search_area .search_btn {
  position: absolute;
  right: 5px;
  height: 4vh;
  border-radius: 0.3rem;
  box-shadow: none;
}
.epos__products .no_prod_alert {
  margin-top: 2vh;
  width: 80%;
  font-size: 1.7rem;
  border-radius: 0.3rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.epos__products .no_prod_alert span {
  text-decoration: underline;
  color: #2c53a0;
  cursor: pointer;
}
.epos__products .found_products {
  table-layout: fixed;
  background-color: #fff;
  border-collapse: collapse;
  color: #4d4d4d;
  width: 90%;
  margin-top: 2vh;
  border-radius: 0.3rem;
}
.epos__products .found_products thead {
  border-bottom: 1px solid #4d4d4d;
  text-align: center;
}
.epos__products .found_products tbody {
  text-align: center;
}
.epos__products .found_products tbody tr {
  border-bottom: 1px solid #4d4d4d;
}
.epos__products .found_products tbody tr:nth-child(odd) {
  background-color: #f2f2f2;
}
.epos__products .found_products tbody tr input {
  width: 20%;
  margin: 0 auto;
  text-align: center;
}
.epos__products .found_products tbody tr:nth-child(odd) {
  background-color: rgb(235, 237, 243);
}
.epos__products .found_products tr th {
  padding: 5px;
}
.epos__products .found_products tr td {
  padding: 5px;
}
.epos__products .found_products tr td button {
  width: 70%;
  background-color: #2c53a0;
}
.epos__products .product_details {
  margin-top: 2vh;
  width: 90vw;
  color: black;
}
.epos__products .product_details .top_btns {
  display: flex;
  justify-content: space-between;
  position: absolute;
  top: 5px;
  right: 5px;
  gap: 5px;
}
.epos__products .product_details .top_btns button {
  font-size: 0.8rem;
}
.epos__products .product_details .bottom_btns {
  display: flex;
  justify-content: space-between;
  gap: 5px;
}
.epos__products .product_details label {
  margin-bottom: 5px;
  font-size: 0.9;
  font-weight: 600;
}
.epos__products .product_details .accordian {
  margin-bottom: 1vh;
}
.epos__products .product_details .accordian .accordian_header {
  background-color: #2c53a0;
  color: #fff;
  font-size: 1.1rem;
}
.epos__products .product_details .accordian input,
.epos__products .product_details .accordian select {
  height: 4vh;
  width: 100%;
  border-radius: 0.3rem;
  outline: none;
  padding: 2px 5px;
  border: 1px solid rgb(179, 172, 172);
}
.epos__products .product_details .accordian .accordian_details {
  padding: 10px 8px;
}
.epos__products .product_details .accordian .accordian_details h3 {
  text-align: center;
}
.epos__products .product_details .accordian .accordian_details .details {
  background-color: rgb(235, 237, 243);
  padding: 10px;
  border-radius: 0.2rem;
  box-shadow: rgba(0, 0, 0, 0.19) 0px 0px 20px, rgba(0, 0, 0, 0.23) 0px 0px 6px;
}
.epos__products .product_details .accordian .accordian_details .details .small_label {
  font-size: 0.8rem;
  color: #2c53a0;
}
.epos__products .product_details .accordian .accordian_details .details .detail_row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1vh;
}
.epos__products .product_details .accordian .accordian_details .details .detail_row .info_section {
  display: flex;
  flex-direction: column;
}
.epos__products .product_details .accordian .accordian_details .details .detail_row .epos_id {
  width: 10%;
}
.epos__products .product_details .accordian .accordian_details .details .detail_row .name,
.epos__products .product_details .accordian .accordian_details .details .detail_row .description,
.epos__products .product_details .accordian .accordian_details .details .detail_row .category {
  width: 42%;
}
.epos__products .product_details .accordian .accordian_details .details .detail_row .order_code,
.epos__products .product_details .accordian .accordian_details .details .detail_row .category,
.epos__products .product_details .accordian .accordian_details .details .detail_row .mainSupplier {
  width: 32%;
}
.epos__products .product_details .accordian .accordian_details .details .detail_row .barcode,
.epos__products .product_details .accordian .accordian_details .details .detail_row .add_barcode {
  width: 48%;
}
.epos__products .product_details .accordian .accordian_details .details .detail_row .barcode .barcode_table {
  border-collapse: collapse;
}
.epos__products .product_details .accordian .accordian_details .details .detail_row .barcode .barcode_table td {
  border: 1px solid #ddd;
  padding: 8px;
  width: 100%;
}
.epos__products .product_details .accordian .accordian_details .details .detail_row .add_barcode .inner_section .add_barcode_btn {
  position: absolute;
  margin-top: 0.2vh;
  right: 20px;
  height: 3.5vh;
  width: 2vw;
  border-radius: 0.3rem;
  box-shadow: none;
}
.epos__products .product_details .accordian .accordian_details .details .detail_row .add_barcode .barcode_alert {
  margin-top: 1vh;
}
.epos__products .product_details .accordian .accordian_details .details .detail_row .cost_price,
.epos__products .product_details .accordian .accordian_details .details .detail_row .sale_price_exc,
.epos__products .product_details .accordian .accordian_details .details .detail_row .vat,
.epos__products .product_details .accordian .accordian_details .details .detail_row .sale_price_inc {
  width: 23%;
}
.epos__products .product_details .accordian .accordian_details .details .detail_row .margin,
.epos__products .product_details .accordian .accordian_details .details .detail_row .profit {
  width: 40%;
}
.epos__products .product_details .accordian .accordian_details .details .detail_row .price_marked {
  display: flex;
  align-items: center;
  width: 15%;
}
.epos__products .product_details .accordian .accordian_details .details .audit_logs_table {
  table-layout: fixed;
  background-color: #fff;
  border-collapse: collapse;
  color: #4d4d4d;
  width: 100%;
}
.epos__products .product_details .accordian .accordian_details .details .audit_logs_table thead {
  border-bottom: 1px solid #4d4d4d;
  text-align: center;
}
.epos__products .product_details .accordian .accordian_details .details .audit_logs_table tbody {
  text-align: center;
}
.epos__products .product_details .accordian .accordian_details .details .audit_logs_table tbody tr {
  border-bottom: 1px solid #4d4d4d;
}
.epos__products .product_details .accordian .accordian_details .details .audit_logs_table tbody tr:nth-child(odd) {
  background-color: #f2f2f2;
}
.epos__products .product_details .accordian .accordian_details .details .audit_logs_table tbody tr input {
  width: 20%;
  margin: 0 auto;
  text-align: center;
}
.epos__products .product_details .accordian .accordian_details .details .audit_logs_table tbody tr:nth-child(odd) {
  background-color: rgb(235, 237, 243);
}
.epos__products .product_details .accordian .accordian_details .details .audit_logs_table tr th {
  padding: 5px;
}
.epos__products .product_details .accordian .accordian_details .details .audit_logs_table tr td {
  padding: 5px;
}
.epos__products .product_details .accordian .accordian_details .details .audit_logs_table tr td button {
  width: 70%;
  background-color: #2c53a0;
}
.epos__products .product_details .accordian .accordian_details .details h3 {
  text-align: center;
}
.epos__products .product_details .accordian .accordian_details .details .supplier_alert {
  width: 100%;
  margin-top: 1vh;
  text-align: center;
}
.epos__products .product_details .accordian .accordian_details .details .supplier_table,
.epos__products .product_details .accordian .accordian_details .details .add_supplier_table {
  table-layout: fixed;
  background-color: #fff;
  border-collapse: collapse;
  color: #4d4d4d;
  width: 100%;
}
.epos__products .product_details .accordian .accordian_details .details .supplier_table thead,
.epos__products .product_details .accordian .accordian_details .details .add_supplier_table thead {
  border-bottom: 1px solid #4d4d4d;
  text-align: center;
}
.epos__products .product_details .accordian .accordian_details .details .supplier_table tbody,
.epos__products .product_details .accordian .accordian_details .details .add_supplier_table tbody {
  text-align: center;
}
.epos__products .product_details .accordian .accordian_details .details .supplier_table tbody tr,
.epos__products .product_details .accordian .accordian_details .details .add_supplier_table tbody tr {
  border-bottom: 1px solid #4d4d4d;
}
.epos__products .product_details .accordian .accordian_details .details .supplier_table tbody tr:nth-child(odd),
.epos__products .product_details .accordian .accordian_details .details .add_supplier_table tbody tr:nth-child(odd) {
  background-color: #f2f2f2;
}
.epos__products .product_details .accordian .accordian_details .details .supplier_table tbody tr input,
.epos__products .product_details .accordian .accordian_details .details .add_supplier_table tbody tr input {
  width: 20%;
  margin: 0 auto;
  text-align: center;
}
.epos__products .product_details .accordian .accordian_details .details .supplier_table .supplier_case,
.epos__products .product_details .accordian .accordian_details .details .supplier_table .supplier_case_barcode,
.epos__products .product_details .accordian .accordian_details .details .supplier_table .supplier_cost,
.epos__products .product_details .accordian .accordian_details .details .supplier_table .order_co,
.epos__products .product_details .accordian .accordian_details .details .add_supplier_table .supplier_case,
.epos__products .product_details .accordian .accordian_details .details .add_supplier_table .supplier_case_barcode,
.epos__products .product_details .accordian .accordian_details .details .add_supplier_table .supplier_cost,
.epos__products .product_details .accordian .accordian_details .details .add_supplier_table .order_co {
  width: 85%;
}
.epos__products .product_details .accordian .accordian_details .details .supplier_table tbody tr:nth-child(odd),
.epos__products .product_details .accordian .accordian_details .details .add_supplier_table tbody tr:nth-child(odd) {
  background-color: rgb(235, 237, 243);
}
.epos__products .product_details .accordian .accordian_details .details .supplier_table tbody tr:nth-child(even),
.epos__products .product_details .accordian .accordian_details .details .add_supplier_table tbody tr:nth-child(even) {
  background-color: rgb(235, 237, 243);
}
.epos__products .product_details .accordian .accordian_details .details .supplier_table tr th,
.epos__products .product_details .accordian .accordian_details .details .add_supplier_table tr th {
  padding: 5px;
}
.epos__products .product_details .accordian .accordian_details .details .supplier_table tr td,
.epos__products .product_details .accordian .accordian_details .details .add_supplier_table tr td {
  padding: 5px;
}
.epos__products .product_details .accordian .accordian_details .details .supplier_table tr td button,
.epos__products .product_details .accordian .accordian_details .details .add_supplier_table tr td button {
  width: 70%;
  background-color: #2c53a0;
}
.epos__products .product_details .accordian .accordian_details .details .add_supplier_table {
  margin-top: 2vh;
}
.epos__products .product_details .accordian .accordian_details .price_history {
  display: flex;
  justify-content: center;
  margin-top: 1vh;
}
.epos__products .product_details .accordian .accordian_details .product_hist {
  display: flex;
  justify-content: center;
  margin-top: 1vh;
}
.epos__products .product_details .accordian .accordian_details .product_hist .prod_hist_table {
  table-layout: fixed;
  background-color: #fff;
  border-collapse: collapse;
  color: #4d4d4d;
  width: 100%;
}
.epos__products .product_details .accordian .accordian_details .product_hist .prod_hist_table thead {
  border-bottom: 1px solid #4d4d4d;
  text-align: center;
}
.epos__products .product_details .accordian .accordian_details .product_hist .prod_hist_table tbody {
  text-align: center;
}
.epos__products .product_details .accordian .accordian_details .product_hist .prod_hist_table tbody tr {
  border-bottom: 1px solid #4d4d4d;
}
.epos__products .product_details .accordian .accordian_details .product_hist .prod_hist_table tbody tr:nth-child(odd) {
  background-color: #f2f2f2;
}
.epos__products .product_details .accordian .accordian_details .product_hist .prod_hist_table tbody tr input {
  width: 20%;
  margin: 0 auto;
  text-align: center;
}
.epos__products .product_details .accordian .accordian_details .product_hist .prod_hist_table .supplier_case,
.epos__products .product_details .accordian .accordian_details .product_hist .prod_hist_table .supplier_cost {
  width: 50%;
}
.epos__products .product_details .accordian .accordian_details .product_hist .prod_hist_table tbody tr:nth-child(odd) {
  background-color: rgb(235, 237, 243);
}
.epos__products .product_details .accordian .accordian_details .product_hist .prod_hist_table tr th {
  padding: 5px;
}
.epos__products .product_details .accordian .accordian_details .product_hist .prod_hist_table tr td {
  padding: 5px;
}
.epos__products .product_details .accordian .accordian_details .product_hist .prod_hist_table tr td button {
  width: 70%;
  background-color: #2c53a0;
}
@media (max-width: 900px) {
  .epos__products .epos__search h1 {
    text-align: left;
    width: 90%;
  }
  .epos__products .epos__search .epos_search .search_area {
    width: 100%;
  }
  .epos__products .epos__search #add_prod_btn {
    width: 80px;
    font-size: 0.5rem;
    padding-right: 5px;
    padding-left: 5px;
  }
  .epos__products .no_prod_alert {
    font-size: 1rem;
  }
  .epos__products .found_products .cost_price_cell {
    display: none;
  }
  .epos__products .product_details .top_btns {
    display: flex;
    flex-direction: column;
  }
  .epos__products .product_details .accordian .accordian_details .details {
    width: 100%;
  }
  .epos__products .product_details .accordian .accordian_details .details .detail_row {
    display: block;
  }
  .epos__products .product_details .accordian .accordian_details .details .detail_row .info_section {
    width: 100%;
    margin-top: 0.5vh;
  }
  .epos__products .product_details .accordian .accordian_details .details .supplier_table,
  .epos__products .product_details .accordian .accordian_details .details .add_supplier_table,
  .epos__products .product_details .accordian .accordian_details .details .audit_logs_table,
  .epos__products .product_details .accordian .accordian_details .details .prod_hist_table {
    border: 0;
    border-collapse: collapse;
    margin: 0;
    padding: 0;
    width: 100%;
    table-layout: fixed;
  }
  .epos__products .product_details .accordian .accordian_details .details .supplier_table thead,
  .epos__products .product_details .accordian .accordian_details .details .add_supplier_table thead,
  .epos__products .product_details .accordian .accordian_details .details .audit_logs_table thead,
  .epos__products .product_details .accordian .accordian_details .details .prod_hist_table thead {
    display: none;
  }
  .epos__products .product_details .accordian .accordian_details .details .supplier_table tr,
  .epos__products .product_details .accordian .accordian_details .details .add_supplier_table tr,
  .epos__products .product_details .accordian .accordian_details .details .audit_logs_table tr,
  .epos__products .product_details .accordian .accordian_details .details .prod_hist_table tr {
    display: block;
    border: 1px solid #fff;
    padding: 1em 1em 0.5em;
  }
  .epos__products .product_details .accordian .accordian_details .details .supplier_table tr + tr,
  .epos__products .product_details .accordian .accordian_details .details .add_supplier_table tr + tr,
  .epos__products .product_details .accordian .accordian_details .details .audit_logs_table tr + tr,
  .epos__products .product_details .accordian .accordian_details .details .prod_hist_table tr + tr {
    margin-top: 0.625em;
  }
  .epos__products .product_details .accordian .accordian_details .details .supplier_table td,
  .epos__products .product_details .accordian .accordian_details .details .add_supplier_table td,
  .epos__products .product_details .accordian .accordian_details .details .audit_logs_table td,
  .epos__products .product_details .accordian .accordian_details .details .prod_hist_table td {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    border-bottom: 1px solid #fff;
    font-size: 0.8em;
    line-height: 1.35em;
  }
  .epos__products .product_details .accordian .accordian_details .details .supplier_table td #delete_sup,
  .epos__products .product_details .accordian .accordian_details .details .supplier_table td #add_sup,
  .epos__products .product_details .accordian .accordian_details .details .add_supplier_table td #delete_sup,
  .epos__products .product_details .accordian .accordian_details .details .add_supplier_table td #add_sup,
  .epos__products .product_details .accordian .accordian_details .details .audit_logs_table td #delete_sup,
  .epos__products .product_details .accordian .accordian_details .details .audit_logs_table td #add_sup,
  .epos__products .product_details .accordian .accordian_details .details .prod_hist_table td #delete_sup,
  .epos__products .product_details .accordian .accordian_details .details .prod_hist_table td #add_sup {
    margin: 0 auto;
  }
  .epos__products .product_details .accordian .accordian_details .details .supplier_table td:before,
  .epos__products .product_details .accordian .accordian_details .details .add_supplier_table td:before,
  .epos__products .product_details .accordian .accordian_details .details .audit_logs_table td:before,
  .epos__products .product_details .accordian .accordian_details .details .prod_hist_table td:before {
    content: attr(data-label);
    font-size: 0.9em;
    text-align: left;
    font-weight: bold;
    text-transform: uppercase;
    max-width: 45%;
    color: #545454;
  }
  .epos__products .product_details .accordian .accordian_details .details .supplier_table td + td,
  .epos__products .product_details .accordian .accordian_details .details .add_supplier_table td + td,
  .epos__products .product_details .accordian .accordian_details .details .audit_logs_table td + td,
  .epos__products .product_details .accordian .accordian_details .details .prod_hist_table td + td {
    margin-top: 0.8em;
  }
  .epos__products .product_details .accordian .accordian_details .details .supplier_table td:last-child,
  .epos__products .product_details .accordian .accordian_details .details .add_supplier_table td:last-child,
  .epos__products .product_details .accordian .accordian_details .details .audit_logs_table td:last-child,
  .epos__products .product_details .accordian .accordian_details .details .prod_hist_table td:last-child {
    border-bottom: 0;
  }
  .epos__products .product_details .accordian .accordian_details .details .supplier_table select,
  .epos__products .product_details .accordian .accordian_details .details .supplier_table input,
  .epos__products .product_details .accordian .accordian_details .details .add_supplier_table select,
  .epos__products .product_details .accordian .accordian_details .details .add_supplier_table input,
  .epos__products .product_details .accordian .accordian_details .details .audit_logs_table select,
  .epos__products .product_details .accordian .accordian_details .details .audit_logs_table input,
  .epos__products .product_details .accordian .accordian_details .details .prod_hist_table select,
  .epos__products .product_details .accordian .accordian_details .details .prod_hist_table input {
    width: 50%;
  }
  .epos__products .product_details .accordian .accordian_details .details .supplier_table .supplier_case,
  .epos__products .product_details .accordian .accordian_details .details .supplier_table .supplier_cost,
  .epos__products .product_details .accordian .accordian_details .details .supplier_table .supplier_auto,
  .epos__products .product_details .accordian .accordian_details .details .supplier_table .order_co,
  .epos__products .product_details .accordian .accordian_details .details .add_supplier_table .supplier_case,
  .epos__products .product_details .accordian .accordian_details .details .add_supplier_table .supplier_cost,
  .epos__products .product_details .accordian .accordian_details .details .add_supplier_table .supplier_auto,
  .epos__products .product_details .accordian .accordian_details .details .add_supplier_table .order_co,
  .epos__products .product_details .accordian .accordian_details .details .audit_logs_table .supplier_case,
  .epos__products .product_details .accordian .accordian_details .details .audit_logs_table .supplier_cost,
  .epos__products .product_details .accordian .accordian_details .details .audit_logs_table .supplier_auto,
  .epos__products .product_details .accordian .accordian_details .details .audit_logs_table .order_co,
  .epos__products .product_details .accordian .accordian_details .details .prod_hist_table .supplier_case,
  .epos__products .product_details .accordian .accordian_details .details .prod_hist_table .supplier_cost,
  .epos__products .product_details .accordian .accordian_details .details .prod_hist_table .supplier_auto,
  .epos__products .product_details .accordian .accordian_details .details .prod_hist_table .order_co {
    margin: 0;
    width: 50%;
  }
}
@media (max-width: 600px) {
  .epos__products .epos__search h1 {
    font-size: 0.9rem;
  }
  .epos__products .product_details .top_btns {
    flex-direction: row;
  }
  .epos__products .product_details .top_btns button {
    font-size: 0.5rem;
  }
  .epos__products .product_details #add_prod_btn_bottom {
    width: 100%;
  }
  .epos__products .product_details #add_prod_btn_bottom .bottom_btns {
    flex-direction: column;
    width: 100%;
  }
  .epos__products .product_details #add_prod_btn_bottom .bottom_btns button {
    width: 100%;
    display: flex;
  }
}

#stockAdd {
  max-height: 35vh;
  overflow-y: auto;
  overflow-x: none;
}
#stockAdd table {
  table-layout: fixed;
  background-color: #fff;
  border-collapse: collapse;
  color: #4d4d4d;
  width: 90%;
  margin: auto;
  table-layout: fixed;
  border-collapse: collapse;
  background-color: #fff;
  color: black;
}
#stockAdd table thead {
  border-bottom: 1px solid #4d4d4d;
  text-align: center;
}
#stockAdd table tbody {
  text-align: center;
}
#stockAdd table tbody tr {
  border-bottom: 1px solid #4d4d4d;
}
#stockAdd table tbody tr:nth-child(odd) {
  background-color: #f2f2f2;
}
#stockAdd table tbody tr input {
  width: 20%;
  margin: 0 auto;
  text-align: center;
}
#stockAdd table thead {
  background-color: #2c53a0;
  color: #fff;
}
@media (max-width: 600px) {
  #stockAdd table tbody tr {
    font-size: 0.6rem;
  }
}
#stockAdd table tbody tr td {
  padding: 2%;
  text-align: center;
}
#stockAdd table tbody tr input {
  width: 50%;
  border: 1px solid grey;
  border-radius: 5px;
}
#stockAdd .btn-section {
  display: flex;
  justify-content: space-between;
  gap: 1vw;
  margin-top: 2vh;
}
#stockAdd .btn-section button {
  width: 40%;
}

.archive-product-modal {
  display: flex;
  flex-direction: column;
}
.archive-product-modal h2 {
  margin: 0;
}
.archive-product-modal p {
  color: #000;
  text-align: center;
}
.archive-product-modal .stock-table-container {
  overflow-y: auto;
  max-height: 40vh;
}
.archive-product-modal .stock-table-container .stock-table {
  color: #000;
  width: 95%;
  font-size: 0.9em;
  font-family: sans-serif;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
  margin: 2vh auto;
  table-layout: fixed;
}
.archive-product-modal .stock-table-container .stock-table thead {
  height: 4vh;
}
.archive-product-modal .stock-table-container .stock-table thead tr {
  background-color: #2c53a0;
  color: #ffffff;
  text-align: left;
}
.archive-product-modal .stock-table-container .stock-table thead tr th {
  text-align: center;
}
.archive-product-modal .stock-table-container .stock-table tbody tr {
  border-bottom: 1px solid #dddddd;
}
.archive-product-modal .stock-table-container .stock-table tbody tr:nth-of-type(even) {
  background-color: #f3f3f3;
}
.archive-product-modal .stock-table-container .stock-table tbody tr:first-of-type {
  border-top: 2px solid #2c53a0;
}
.archive-product-modal .stock-table-container .stock-table tbody tr:last-of-type {
  border-bottom: 2px solid #2c53a0;
}
.archive-product-modal .stock-table-container .stock-table tbody tr td {
  padding: 12px 15px;
  word-wrap: break-word;
}
.archive-product-modal .stock-table-container .stock-table tbody tr td .input_number {
  border-radius: 3px;
  border: 2px solid #2c53a0;
  width: 50px;
  height: 3vh;
  text-align: center;
}
.archive-product-modal .stock-table-container .stock-table tbody tr td input::-webkit-outer-spin-button,
.archive-product-modal .stock-table-container .stock-table tbody tr td input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.archive-product-modal .stock-table-container .stock-table tbody tr td span {
  font-weight: 700;
  padding: 0 1vw;
}
.archive-product-modal .stock-table-container .stock-table tbody tr .icon {
  cursor: pointer;
}
.archive-product-modal .stock-table-container .stock-table tbody tr .info-cell {
  margin: 0 auto;
}
.archive-product-modal .stock-table-container .stock-table tbody tr .approve-deny-cell,
.archive-product-modal .stock-table-container .stock-table tbody tr .info-cell {
  display: flex;
  justify-content: space-around;
}
.archive-product-modal .alert-section {
  height: 7vh;
}
.archive-product-modal .btn-section {
  display: flex;
  justify-content: space-evenly;
  gap: 10px;
}
.archive-product-modal .btn-section button {
  width: 100%;
}

::-webkit-scrollbar {
  background: #2c53a0;
  width: 0.9vw;
}

::-webkit-scrollbar-thumb {
  background: #64c4e0;
}`, "",{"version":3,"sources":["webpack://./src/components/variables.scss","webpack://./src/components/managerZone/epos/products/products.scss"],"names":[],"mappings":"AAOA,eAAA;AAeA;EACI,iCAAA;EACA,4CAAA;ACpBJ;AAFA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAIJ;AAFI;;EAEI,wBAAA;EACA,SAAA;AAIR;AADI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AAGR;AADQ;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;AAGZ;AADQ;EACI,aAAA;EACA,oBAAA;AAGZ;AAFY;EACI,eAAA;EACA,YAAA;AAIhB;AAAQ;EACI,yBAAA;EACA,WAAA;EACA,sBAAA;EACA,qBAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,QAAA;EACA,aAAA;AAEZ;AAAY;EACI,UAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,kBAAA;AAEhB;AADgB;;EAEI,WAAA;EACA,WAAA;EACA,qBAAA;EACA,aAAA;EACA,gBAAA;EACA,oCAAA;AAGpB;AAAgB;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;AAEpB;AAII;EACI,eAAA;EACA,UAAA;EACA,iBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAFR;AAIQ;EACI,0BAAA;EACA,cDvFA;ECwFA,eAAA;AAFZ;AAMI;ED2CA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAvIQ;EC2FJ,UAAA;EACA,eAAA;EACA,qBAAA;AADR;AD4CI;EACI,gCAAA;EACA,kBAAA;AC1CR;AD4CI;EACI,kBAAA;AC1CR;AD2CQ;EACI,gCAAA;ACzCZ;AD0CY;EACI,yBAAA;ACxChB;AD0CY;EACI,UAAA;EACA,cAAA;EACA,kBAAA;ACxChB;AAfQ;EACI,oCAAA;AAiBZ;AAbY;EACI,YAAA;AAehB;AAbY;EACI,YAAA;AAehB;AAdgB;EACI,UAAA;EACA,yBD9GR;AC8HZ;AAVI;EACI,eAAA;EACA,WAAA;EACA,YAAA;AAYR;AAVQ;EACI,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,QAAA;AAYZ;AAXY;EACI,iBAAA;AAahB;AAVQ;EACI,aAAA;EACA,8BAAA;EACA,QAAA;AAYZ;AAVQ;EACI,kBAAA;EACA,cAAA;EACA,gBAAA;AAYZ;AAVQ;EACI,kBAAA;AAYZ;AAVY;EACI,yBDlJJ;ECmJI,WAAA;EACA,iBAAA;AAYhB;AATY;;EAEI,WAAA;EACA,WAAA;EACA,qBAAA;EACA,aAAA;EACA,gBAAA;EACA,oCAAA;AAWhB;AATY;EACI,iBAAA;AAWhB;AAVgB;EACI,kBAAA;AAYpB;AAVgB;EACI,oCAAA;EACA,aAAA;EACA,qBAAA;EACA,6EAAA;AAYpB;AAVoB;EACI,iBAAA;EACA,cD7KZ;ACyLZ;AAVoB;EACI,aAAA;EACA,8BAAA;EACA,kBAAA;AAYxB;AAXwB;EACI,aAAA;EACA,sBAAA;AAa5B;AAVwB;EACI,UAAA;AAY5B;AAVwB;;;EAGI,UAAA;AAY5B;AAVwB;;;EAGI,UAAA;AAY5B;AATwB;;EAEI,UAAA;AAW5B;AAP4B;EACI,yBAAA;AAShC;AARgC;EACI,sBAAA;EACA,YAAA;EACA,WAAA;AAUpC;AAHgC;EACI,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;EACA,qBAAA;EACA,gBAAA;AAKpC;AAF4B;EACI,eAAA;AAIhC;AAAwB;;;;EAII,UAAA;AAE5B;AACwB;;EAEI,UAAA;AAC5B;AAEwB;EACI,aAAA;EACA,mBAAA;EACA,UAAA;AAA5B;AAIoB;EDnHhB,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAvIQ;ECyPY,WAAA;AACxB;ADlHI;EACI,gCAAA;EACA,kBAAA;ACoHR;ADlHI;EACI,kBAAA;ACoHR;ADnHQ;EACI,gCAAA;ACqHZ;ADpHY;EACI,yBAAA;ACsHhB;ADpHY;EACI,UAAA;EACA,cAAA;EACA,kBAAA;ACsHhB;AAjBwB;EACI,oCAAA;AAmB5B;AAf4B;EACI,YAAA;AAiBhC;AAf4B;EACI,YAAA;AAiBhC;AAhBgC;EACI,UAAA;EACA,yBD1QxB;AC4RZ;AAboB;EACI,kBAAA;AAexB;AAboB;EACI,WAAA;EACA,eAAA;EACA,kBAAA;AAexB;AAboB;;EDhJhB,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAvIQ;ECuRY,WAAA;AAkBxB;ADjKI;;EACI,gCAAA;EACA,kBAAA;ACoKR;ADlKI;;EACI,kBAAA;ACqKR;ADpKQ;;EACI,gCAAA;ACuKZ;ADtKY;;EACI,yBAAA;ACyKhB;ADvKY;;EACI,UAAA;EACA,cAAA;EACA,kBAAA;AC0KhB;AAvCwB;;;;;;;;EAII,UAAA;AA6C5B;AA1CwB;;EACI,oCAAA;AA6C5B;AA3CwB;;EACI,oCAAA;AA8C5B;AA1C4B;;EACI,YAAA;AA6ChC;AA3C4B;;EACI,YAAA;AA8ChC;AA7CgC;;EACI,UAAA;EACA,yBDlTxB;ACkWZ;AA3CoB;EACI,eAAA;AA6CxB;AAzCgB;EACI,aAAA;EACA,uBAAA;EACA,eAAA;AA2CpB;AAzCgB;EACI,aAAA;EACA,uBAAA;EACA,eAAA;AA2CpB;AA1CoB;ED9LhB,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAvIQ;ECoUY,WAAA;AA+CxB;AD3OI;EACI,gCAAA;EACA,kBAAA;AC6OR;AD3OI;EACI,kBAAA;AC6OR;AD5OQ;EACI,gCAAA;AC8OZ;AD7OY;EACI,yBAAA;AC+OhB;AD7OY;EACI,UAAA;EACA,cAAA;EACA,kBAAA;AC+OhB;AA/DwB;;EAEI,UAAA;AAiE5B;AA9DwB;EACI,oCAAA;AAgE5B;AA5D4B;EACI,YAAA;AA8DhC;AA5D4B;EACI,YAAA;AA8DhC;AA7DgC;EACI,UAAA;EACA,yBD1VxB;ACyZZ;AAnDI;EAEQ;IACI,gBAAA;IACA,UAAA;EAoDd;EAjDc;IACI,WAAA;EAmDlB;EAhDU;IACI,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,iBAAA;EAkDd;EA9CM;IACI,eAAA;EAgDV;EA5CU;IACI,aAAA;EA8Cd;EAzCU;IACI,aAAA;IACA,sBAAA;EA2Cd;EAvCkB;IACI,WAAA;EAyCtB;EAxCsB;IACI,cAAA;EA0C1B;EAxC0B;IACI,WAAA;IACA,iBAAA;EA0C9B;EAtCsB;;;;IAII,SAAA;IACA,yBAAA;IACA,SAAA;IACA,UAAA;IACA,WAAA;IACA,mBAAA;EAwC1B;EAvC0B;;;;IACI,aAAA;EA4C9B;EA1C0B;;;;IACI,cAAA;IACA,sBAAA;IACA,sBAAA;EA+C9B;EA7C8B;;;;IACI,mBAAA;EAkDlC;EA/C0B;;;;IACI,aAAA;IACA,8BAAA;IACA,qBAAA;IACA,6BAAA;IACA,gBAAA;IACA,mBAAA;EAoD9B;EAlD8B;;;;;;;;IAEI,cAAA;EA0DlC;EAvD8B;;;;IACI,yBAAA;IACA,gBAAA;IACA,gBAAA;IACA,iBAAA;IACA,yBAAA;IACA,cAAA;IACA,cAAA;EA4DlC;EAzD8B;;;;IACI,iBAAA;EA8DlC;EA3D8B;;;;IACI,gBAAA;EAgElC;EA7D0B;;;;;;;;IAEI,UAAA;EAqE9B;EAnE0B;;;;;;;;;;;;;;;;IAII,SAAA;IACA,UAAA;EAiF9B;AACF;AAzEI;EAEQ;IACI,iBAAA;EA0Ed;EAtEU;IACI,mBAAA;EAwEd;EAvEc;IACI,iBAAA;EAyElB;EAtEU;IACI,WAAA;EAwEd;EAvEc;IACI,sBAAA;IACA,WAAA;EAyElB;EAxEkB;IACI,WAAA;IACA,aAAA;EA0EtB;AACF;;AAnEA;EACI,gBAAA;EACA,gBAAA;EACA,gBAAA;AAsEJ;AArEI;EDrXA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAvIQ;EC2fJ,UAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,YAAA;AA0ER;ADlcI;EACI,gCAAA;EACA,kBAAA;ACocR;ADlcI;EACI,kBAAA;ACocR;ADncQ;EACI,gCAAA;ACqcZ;ADpcY;EACI,yBAAA;ACschB;ADpcY;EACI,UAAA;EACA,cAAA;EACA,kBAAA;ACschB;AA1FQ;EACI,yBDtgBA;ECugBA,WAAA;AA4FZ;AAvFgB;EADJ;IAEQ,iBAAA;EA0FlB;AACF;AAxFgB;EACI,WAAA;EACA,kBAAA;AA0FpB;AAxFgB;EACI,UAAA;EACA,sBAAA;EACA,kBAAA;AA0FpB;AArFI;EACI,aAAA;EACA,8BAAA;EACA,QAAA;EACA,eAAA;AAuFR;AAtFQ;EACI,UAAA;AAwFZ;;AApFA;EACI,aAAA;EACA,sBAAA;AAuFJ;AArFI;EACI,SAAA;AAuFR;AApFI;EACI,WAAA;EACA,kBAAA;AAsFR;AAnFI;EACI,gBAAA;EACA,gBAAA;AAqFR;AApFQ;EACI,WAAA;EACA,UAAA;EACA,gBAAA;EACA,uBAAA;EACA,wCAAA;EACA,gBAAA;EACA,mBAAA;AAsFZ;AArFY;EACI,WAAA;AAuFhB;AAtFgB;EACI,yBDjkBR;ECkkBQ,cAAA;EACA,gBAAA;AAwFpB;AAvFoB;EACI,kBAAA;AAyFxB;AAnFgB;EACI,gCAAA;AAqFpB;AAnFoB;EACI,yBAAA;AAqFxB;AAnFoB;EACI,6BAAA;AAqFxB;AAnFoB;EACI,gCAAA;AAqFxB;AAlFoB;EACI,kBAAA;EACA,qBAAA;AAoFxB;AAnFwB;EACI,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;AAqF5B;AAnFwB;;EAEI,wBAAA;EACA,SAAA;AAqF5B;AAnFwB;EACI,gBAAA;EACA,cAAA;AAqF5B;AAlFoB;EACI,eAAA;AAoFxB;AAjFoB;EACI,cAAA;AAmFxB;AAjFoB;;EAEI,aAAA;EACA,6BAAA;AAmFxB;AA7EI;EACI,WAAA;AA+ER;AA7EI;EACI,aAAA;EACA,6BAAA;EACA,SAAA;AA+ER;AA9EQ;EACI,WAAA;AAgFZ;;AA5EA;EACI,mBDzoBQ;EC0oBR,YAAA;AA+EJ;;AA5EA;EACI,mBD7oBS;AC4tBb","sourcesContent":["$nitroDark: #2c53a0;\n$nitroLight: #64c4e0;\n$background: #e4ffff;\n$fontColor: #4d4d4d;\n$error: #bb0000;\n$warning: #f29422;\n\n/*media breaks*/\n$mobile: 600px;\n$tablet: 768px;\n$laptop: 900px;\n$tabletMin: 691px;\n$tabletMax: 850px;\n$landsTabletMin: 851px;\n$landsTabletMax: 1300px;\n$smallLaptopMin: 1301px;\n$smallLaptopMax: 1439px;\n$smallScreen: 1440px;\n$regularScreen: 1900px;\n$bigScreen: 1920px;\n$fourK: 2000px;\n\n@font-face {\n    font-family: \"digital-clock-font\";\n    src: url(\"./Fuel/font/digital-7.ttf\");\n}\n\n@mixin shadow {\n    box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n@mixin card {\n    background-color: #fff;\n    @include shadow;\n    border-radius: 1rem;\n}\n\n@mixin alertCard {\n    box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px,\n        rgba(0, 0, 0, 0.23) 0px 6px 6px;\n    background-color: #fff;\n    border-radius: 0.5rem;\n}\n\n@mixin eposCard {\n    background-color: #fff;\n    box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px,\n        rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px,\n        rgba(0, 0, 0, 0.09) 0px 32px 16px;\n}\n\n@mixin flex($d: row, $j: center, $a: center, $g: 1vw) {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: $d;\n    justify-content: $j;\n    align-items: $a;\n    gap: $g;\n}\n\n@mixin columnStack {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin columnStart {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n}\n@mixin columnAlignStart {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n@mixin columnAlignStartTop {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n@mixin rowEven {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    flex-wrap: wrap;\n}\n\n@mixin rowEvenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-evenly;\n}\n@mixin rowEvenStartCenter {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n}\n@mixin rowBetween {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n@mixin rowBetweenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n@mixin rowCenter {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n@mixin table {\n    table-layout: fixed;\n    background-color: #fff;\n    border-collapse: collapse;\n    color: $fontColor;\n    thead {\n        border-bottom: 1px solid $fontColor;\n        text-align: center;\n    }\n    tbody {\n        text-align: center;\n        tr {\n            border-bottom: 1px solid $fontColor;\n            &:nth-child(odd) {\n                background-color: #f2f2f2;\n            }\n            input {\n                width: 20%;\n                margin: 0 auto;\n                text-align: center;\n            }\n        }\n    }\n}\n\n//MODAL STYLING\n\n@mixin modal($h: auto, $w: auto) {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: $w;\n    height: $h;\n    max-height: 50vh;\n    background-color: #fff;\n    border: 2px solid #000;\n    box-shadow: 24;\n    padding: 10px;\n    overflow-y: auto;\n    @media (max-width: 600px) {\n        width: 95vw;\n    }\n}\n","@import \"../../../variables.scss\";\n\n.epos__products {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    input::-webkit-outer-spin-button,\n    input::-webkit-inner-spin-button {\n        -webkit-appearance: none;\n        margin: 0;\n    }\n\n    .epos__search {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: flex-start;\n        min-height: 72.1vh;\n        position: relative;\n        width: 100%;\n\n        #add_prod_btn {\n            position: absolute;\n            top: 5px;\n            right: 5px;\n            width: 200px;\n        }\n        #add_prod_btn_bottom {\n            display: flex;\n            justify-content: end;\n            button {\n                margin-top: 1vh;\n                width: 200px;\n            }\n        }\n\n        .epos_search {\n            border: 1px solid $nitroDark;\n            width: 90vw;\n            background-color: #fff;\n            border-radius: 0.3rem;\n            display: flex;\n            justify-content: center;\n            flex-wrap: wrap;\n            gap: 5px;\n            padding: 10px;\n\n            .search_area {\n                width: 48%;\n                display: flex;\n                justify-content: space-evenly;\n                align-items: center;\n                position: relative;\n                input,\n                select {\n                    height: 5vh;\n                    width: 100%;\n                    border-radius: 0.3rem;\n                    outline: none;\n                    padding: 2px 5px;\n                    border: 1px solid rgb(179, 172, 172);\n                }\n\n                .search_btn {\n                    position: absolute;\n                    right: 5px;\n                    height: 4vh;\n                    border-radius: 0.3rem;\n                    box-shadow: none;\n                }\n            }\n        }\n    }\n\n    .no_prod_alert {\n        margin-top: 2vh;\n        width: 80%;\n        font-size: 1.7rem;\n        border-radius: 0.3rem;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        span {\n            text-decoration: underline;\n            color: $nitroDark;\n            cursor: pointer;\n        }\n    }\n\n    .found_products {\n        @include table;\n        width: 90%;\n        margin-top: 2vh;\n        border-radius: 0.3rem;\n\n        tbody tr:nth-child(odd) {\n            background-color: rgb(235, 237, 243);\n        }\n\n        tr {\n            th {\n                padding: 5px;\n            }\n            td {\n                padding: 5px;\n                button {\n                    width: 70%;\n                    background-color: $nitroDark;\n                }\n            }\n        }\n    }\n\n    .product_details {\n        margin-top: 2vh;\n        width: 90vw;\n        color: black;\n\n        .top_btns {\n            display: flex;\n            justify-content: space-between;\n            position: absolute;\n            top: 5px;\n            right: 5px;\n            gap: 5px;\n            button {\n                font-size: 0.8rem;\n            }\n        }\n        .bottom_btns {\n            display: flex;\n            justify-content: space-between;\n            gap: 5px;\n        }\n        label {\n            margin-bottom: 5px;\n            font-size: 0.9;\n            font-weight: 600;\n        }\n        .accordian {\n            margin-bottom: 1vh;\n\n            .accordian_header {\n                background-color: $nitroDark;\n                color: #fff;\n                font-size: 1.1rem;\n            }\n\n            input,\n            select {\n                height: 4vh;\n                width: 100%;\n                border-radius: 0.3rem;\n                outline: none;\n                padding: 2px 5px;\n                border: 1px solid rgb(179, 172, 172);\n            }\n            .accordian_details {\n                padding: 10px 8px;\n                h3 {\n                    text-align: center;\n                }\n                .details {\n                    background-color: rgb(235, 237, 243);\n                    padding: 10px;\n                    border-radius: 0.2rem;\n                    box-shadow: rgba(0, 0, 0, 0.19) 0px 0px 20px,\n                        rgba(0, 0, 0, 0.23) 0px 0px 6px;\n                    .small_label {\n                        font-size: 0.8rem;\n                        color: $nitroDark;\n                    }\n                    .detail_row {\n                        display: flex;\n                        justify-content: space-between;\n                        margin-bottom: 1vh;\n                        .info_section {\n                            display: flex;\n                            flex-direction: column;\n                        }\n\n                        .epos_id {\n                            width: 10%;\n                        }\n                        .name,\n                        .description,\n                        .category {\n                            width: 42%;\n                        }\n                        .order_code,\n                        .category,\n                        .mainSupplier {\n                            width: 32%;\n                        }\n\n                        .barcode,\n                        .add_barcode {\n                            width: 48%;\n                        }\n\n                        .barcode {\n                            .barcode_table {\n                                border-collapse: collapse;\n                                td {\n                                    border: 1px solid #ddd;\n                                    padding: 8px;\n                                    width: 100%;\n                                }\n                            }\n                        }\n\n                        .add_barcode {\n                            .inner_section {\n                                .add_barcode_btn {\n                                    position: absolute;\n                                    margin-top: 0.2vh;\n                                    right: 20px;\n                                    height: 3.5vh;\n                                    width: 2vw;\n                                    border-radius: 0.3rem;\n                                    box-shadow: none;\n                                }\n                            }\n                            .barcode_alert {\n                                margin-top: 1vh;\n                            }\n                        }\n\n                        .cost_price,\n                        .sale_price_exc,\n                        .vat,\n                        .sale_price_inc {\n                            width: 23%;\n                        }\n\n                        .margin,\n                        .profit {\n                            width: 40%;\n                        }\n\n                        .price_marked {\n                            display: flex;\n                            align-items: center;\n                            width: 15%;\n                        }\n                    }\n\n                    .audit_logs_table {\n                        @include table;\n                        width: 100%;\n\n                        tbody tr:nth-child(odd) {\n                            background-color: rgb(235, 237, 243);\n                        }\n\n                        tr {\n                            th {\n                                padding: 5px;\n                            }\n                            td {\n                                padding: 5px;\n                                button {\n                                    width: 70%;\n                                    background-color: $nitroDark;\n                                }\n                            }\n                        }\n                    }\n                    h3 {\n                        text-align: center;\n                    }\n                    .supplier_alert {\n                        width: 100%;\n                        margin-top: 1vh;\n                        text-align: center;\n                    }\n                    .supplier_table,\n                    .add_supplier_table {\n                        @include table;\n                        width: 100%;\n\n                        .supplier_case,\n                        .supplier_case_barcode,\n                        .supplier_cost,\n                        .order_co {\n                            width: 85%;\n                        }\n\n                        tbody tr:nth-child(odd) {\n                            background-color: rgb(235, 237, 243);\n                        }\n                        tbody tr:nth-child(even) {\n                            background-color: rgb(235, 237, 243);\n                        }\n\n                        tr {\n                            th {\n                                padding: 5px;\n                            }\n                            td {\n                                padding: 5px;\n                                button {\n                                    width: 70%;\n                                    background-color: $nitroDark;\n                                }\n                            }\n                        }\n                    }\n                    .add_supplier_table {\n                        margin-top: 2vh;\n                    }\n                }\n\n                .price_history {\n                    display: flex;\n                    justify-content: center;\n                    margin-top: 1vh;\n                }\n                .product_hist {\n                    display: flex;\n                    justify-content: center;\n                    margin-top: 1vh;\n                    .prod_hist_table {\n                        @include table;\n                        width: 100%;\n\n                        .supplier_case,\n                        .supplier_cost {\n                            width: 50%;\n                        }\n\n                        tbody tr:nth-child(odd) {\n                            background-color: rgb(235, 237, 243);\n                        }\n\n                        tr {\n                            th {\n                                padding: 5px;\n                            }\n                            td {\n                                padding: 5px;\n                                button {\n                                    width: 70%;\n                                    background-color: $nitroDark;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    //MEDIA QUERIES\n\n    @media (max-width: $laptop) {\n        .epos__search {\n            h1 {\n                text-align: left;\n                width: 90%;\n            }\n            .epos_search {\n                .search_area {\n                    width: 100%;\n                }\n            }\n            #add_prod_btn {\n                width: 80px;\n                font-size: 0.5rem;\n                padding-right: 5px;\n                padding-left: 5px;\n            }\n        }\n\n        .no_prod_alert {\n            font-size: 1rem;\n        }\n\n        .found_products {\n            .cost_price_cell {\n                display: none;\n            }\n        }\n\n        .product_details {\n            .top_btns {\n                display: flex;\n                flex-direction: column;\n            }\n            .accordian {\n                .accordian_details {\n                    .details {\n                        width: 100%;\n                        .detail_row {\n                            display: block;\n\n                            .info_section {\n                                width: 100%;\n                                margin-top: 0.5vh;\n                            }\n                        }\n\n                        .supplier_table,\n                        .add_supplier_table,\n                        .audit_logs_table,\n                        .prod_hist_table {\n                            border: 0;\n                            border-collapse: collapse;\n                            margin: 0;\n                            padding: 0;\n                            width: 100%;\n                            table-layout: fixed;\n                            thead {\n                                display: none;\n                            }\n                            tr {\n                                display: block;\n                                border: 1px solid #fff;\n                                padding: 1em 1em 0.5em;\n\n                                & + tr {\n                                    margin-top: 0.625em;\n                                }\n                            }\n                            td {\n                                display: flex;\n                                justify-content: space-between;\n                                align-items: flex-end;\n                                border-bottom: 1px solid #fff;\n                                font-size: 0.8em;\n                                line-height: 1.35em;\n\n                                #delete_sup,\n                                #add_sup {\n                                    margin: 0 auto;\n                                }\n\n                                &:before {\n                                    content: attr(data-label);\n                                    font-size: 0.9em;\n                                    text-align: left;\n                                    font-weight: bold;\n                                    text-transform: uppercase;\n                                    max-width: 45%;\n                                    color: #545454;\n                                }\n\n                                & + td {\n                                    margin-top: 0.8em;\n                                }\n\n                                &:last-child {\n                                    border-bottom: 0;\n                                }\n                            }\n                            select,\n                            input {\n                                width: 50%;\n                            }\n                            .supplier_case,\n                            .supplier_cost,\n                            .supplier_auto,\n                            .order_co {\n                                margin: 0;\n                                width: 50%;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    @media (max-width: 600px) {\n        .epos__search {\n            h1 {\n                font-size: 0.9rem;\n            }\n        }\n        .product_details {\n            .top_btns {\n                flex-direction: row;\n                button {\n                    font-size: 0.5rem;\n                }\n            }\n            #add_prod_btn_bottom {\n                width: 100%;\n                .bottom_btns {\n                    flex-direction: column;\n                    width: 100%;\n                    button {\n                        width: 100%;\n                        display: flex;\n                    }\n                }\n            }\n        }\n    }\n}\n\n#stockAdd {\n    max-height: 35vh;\n    overflow-y: auto;\n    overflow-x: none;\n    table {\n        @include table;\n        width: 90%;\n        margin: auto;\n        table-layout: fixed;\n        border-collapse: collapse;\n        background-color: #fff;\n        color: black;\n\n        thead {\n            background-color: $nitroDark;\n            color: #fff;\n        }\n\n        tbody {\n            tr {\n                @media (max-width: $mobile) {\n                    font-size: 0.6rem;\n                }\n\n                td {\n                    padding: 2%;\n                    text-align: center;\n                }\n                input {\n                    width: 50%;\n                    border: 1px solid grey;\n                    border-radius: 5px;\n                }\n            }\n        }\n    }\n    .btn-section {\n        display: flex;\n        justify-content: space-between;\n        gap: 1vw;\n        margin-top: 2vh;\n        button {\n            width: 40%;\n        }\n    }\n}\n.archive-product-modal {\n    display: flex;\n    flex-direction: column;\n\n    h2 {\n        margin: 0;\n    }\n\n    p {\n        color: #000;\n        text-align: center;\n    }\n\n    .stock-table-container {\n        overflow-y: auto;\n        max-height: 40vh;\n        .stock-table {\n            color: #000;\n            width: 95%;\n            font-size: 0.9em;\n            font-family: sans-serif;\n            box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);\n            margin: 2vh auto;\n            table-layout: fixed;\n            thead {\n                height: 4vh;\n                tr {\n                    background-color: $nitroDark;\n                    color: #ffffff;\n                    text-align: left;\n                    th {\n                        text-align: center;\n                    }\n                }\n            }\n\n            tbody {\n                tr {\n                    border-bottom: 1px solid #dddddd;\n\n                    &:nth-of-type(even) {\n                        background-color: #f3f3f3;\n                    }\n                    &:first-of-type {\n                        border-top: 2px solid $nitroDark;\n                    }\n                    &:last-of-type {\n                        border-bottom: 2px solid $nitroDark;\n                    }\n\n                    td {\n                        padding: 12px 15px;\n                        word-wrap: break-word;\n                        .input_number {\n                            border-radius: 3px;\n                            border: 2px solid $nitroDark;\n                            width: 50px;\n                            height: 3vh;\n                            text-align: center;\n                        }\n                        input::-webkit-outer-spin-button,\n                        input::-webkit-inner-spin-button {\n                            -webkit-appearance: none;\n                            margin: 0;\n                        }\n                        span {\n                            font-weight: 700;\n                            padding: 0 1vw;\n                        }\n                    }\n                    .icon {\n                        cursor: pointer;\n                    }\n\n                    .info-cell {\n                        margin: 0 auto;\n                    }\n                    .approve-deny-cell,\n                    .info-cell {\n                        display: flex;\n                        justify-content: space-around;\n                    }\n                }\n            }\n        }\n    }\n    .alert-section {\n        height: 7vh;\n    }\n    .btn-section {\n        display: flex;\n        justify-content: space-evenly;\n        gap: 10px;\n        button {\n            width: 100%;\n        }\n    }\n}\n::-webkit-scrollbar {\n    background: $nitroDark;\n    width: 0.9vw;\n}\n\n::-webkit-scrollbar-thumb {\n    background: $nitroLight;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
